/**
 *
 * @param place
 * @returns {{adPostCode: (string|string), adCountry: (string|string), adStreetNumber: (string|string), adDistrict: (string|string), lng: number, adCity: (string|string), adStreet: (string|string), plusCode: (string|string), streetAddress: (string|string), route: (string|string), lat: number}}
 */
export const extractPlaceData = (place) => {
  const adStreetNumber = place?.address_components.find((ad) => ad.types.includes("street_number"))?.long_name ?? "";
  const adStreet = place?.address_components.find((ad) => ad.types.includes("route"))?.long_name ?? "";
  const adDistrict = place?.address_components.find((ad) => ad.types.includes("sublocality"))?.long_name ?? "";
  const adPostCode = place?.address_components.find((ad) => ad.types.includes("postal_code"))?.long_name ?? "";
  const adCity = place?.address_components.find((ad) => ad.types.includes("locality"))?.long_name ?? "";
  const adCountry = place?.address_components.find((ad) => ad.types.includes("country"))?.short_name ?? "";

  const plusCode = place?.address_components.find((ad) => ad.types.includes("plus_code"))?.formatted_address ?? "";
  const streetAddress =
    place?.address_components.find((ad) => ad.types.includes("street_address"))?.formatted_address ?? "";
  const route = place?.address_components.find((ad) => ad.types.includes("route"))?.formatted_address ?? "";

  const lat = place?.geometry.location.lat();
  const lng = place?.geometry.location.lng();
  return {
    adCountry,
    adStreetNumber,
    adStreet,
    adDistrict,
    adPostCode,
    adCity,
    lat,
    lng,
    plusCode,
    streetAddress,
    route,
  };
};

/**
 *
 * @param place
 * @param formPrefix
 */
export const fillReportIncidentForm = (place, formPrefix) => {
  const incidentForm = document.querySelector(`div.${formPrefix}-form`);
  if (incidentForm) {
    const placeData = extractPlaceData(place);

    const street = incidentForm.querySelector(`input#${formPrefix}-street`);
    if (street) {
      street.value = `${placeData.adStreet ?? ""}${placeData.adStreetNumber ? ` ${placeData.adStreetNumber}` : ""}`;
    }

    const address = incidentForm.querySelector(`input#${formPrefix}-address`);
    if (address) {
      address.value = `${placeData.adStreet ?? ""}${placeData.adStreetNumber ? ` ${placeData.adStreetNumber}` : ""}`;
    }

    const region = incidentForm.querySelector(`input#${formPrefix}-region`);
    if (region) {
      region.value = "";
    }

    const post_code = incidentForm.querySelector(`input#${formPrefix}-post_code`);
    if (post_code) {
      post_code.value = placeData.adPostCode ?? "";
    }
    const zipcode = incidentForm.querySelector(`input#${formPrefix}-zipcode`);
    if (zipcode) {
      zipcode.value = placeData.adPostCode ?? "";
    }

    const city = incidentForm.querySelector(`input#${formPrefix}-city`);
    if (city) {
      city.value = placeData.adCity ?? "";
    }

    const district_of_city = incidentForm.querySelector(`input#${formPrefix}-district_of_city`);
    if (district_of_city) {
      district_of_city.value = placeData.adDistrict ?? "";
    }

    const latitude = incidentForm.querySelector(`input#${formPrefix}-latitude`);
    if (latitude) {
      latitude.value = placeData.lat.toString().substring(0, 14) ?? "";
    }

    const longitude = incidentForm.querySelector(`input#${formPrefix}-longitude`);
    if (longitude) {
      longitude.value = placeData.lng.toString().substring(0, 14) ?? "";
    }

    const config_country_id = incidentForm.querySelector(`select#${formPrefix}-config_country_id`);
    if (config_country_id && typeof window.country_list === "object") {
      //* var country_list = {af: 1, ax: 2, al: 3, dz: 4, as: 5, ad: 6, ao: 7 ...
      //* 2-char country code, lowercase -> country-id
      const countryId = window.country_list[placeData.adCountry?.toLowerCase()] ?? "";
      if (countryId) {
        for (let i = 0; i < config_country_id.options.length; i++) {
          config_country_id.options[i].selected =
            config_country_id.options[i].value.toString() === countryId.toString();
        }
        config_country_id.dispatchEvent(new Event("change"));
      }
    }
  }
};

export const addressWrapper = (text, fillInFormCallback, place, formPrefix) => {
  const wrapper = document.createElement("div");

  const header = document.createElement("div");
  header.className = "card-header text-white bg-secondary card-body";
  header.innerText = "Address:";
  wrapper.appendChild(header);

  const address = document.createElement("div");
  address.innerText = text;
  address.style.padding = "10px";
  wrapper.appendChild(address);

  if (fillInFormCallback) {
    const addressLink = document.createElement("a");
    addressLink.innerText = "Use address in form";
    addressLink.style.textDecoration = "underline";
    addressLink.style.margin = "10px";
    addressLink.style.display = "block";
    addressLink.style.cursor = "pointer";
    addressLink.onclick = (event) => {
      event.preventDefault();
      event.stopPropagation();
      fillInFormCallback(place, formPrefix);
    };
    wrapper.appendChild(addressLink);
  }

  return wrapper;
};

document.onfullscreenchange = function (event) {
  let target = event.target;
  let pacContainerElements = document.getElementsByClassName("pac-container");
  if (pacContainerElements.length > 0) {
    let pacContainer = document.getElementsByClassName("pac-container")[0];
    if (pacContainer.parentElement === target) {
      document.getElementsByTagName("body")[0].appendChild(pacContainer);
      pacContainer.className += pacContainer.className.replace("fullscreen-pac-container", "");
    } else {
      target.appendChild(pacContainer);
      pacContainer.className += " fullscreen-pac-container";
    }
  }
};
